import { z } from 'zod';

export const RequestResetPasswordSchema = z.object({
  identifier: z.string().trim().min(1, 'form.errors.emailPhoneRequired'),
});

export const ResetPasswordSchema = z.object({
  code: z.string().trim().min(1, 'form.errors.codeRequired'),
  newPassword: z.string().min(8, 'form.errors.passwordRequired'),
});
